$(function () {
    // 完了, 保留, 問診依頼, 再撮影依頼ボタン押下時
    $('.js-btn-complete, .js-btn-pending, .js-btn-request_interview, .js-btn-call, .js-btn-requested_card_resend').on('click', (e) => {
        $(this).prop('disabled', 'true');
        e.preventDefault();
        e.stopPropagation();
        const target = e.target;
        const link = e.target.href;
        const text = e.target.text;
        actionConfirmModal(target, link, text);
    });
    // Waitlist確認モーダル
    function actionConfirmModal(target, link, text) {
        const isRequestInterview = $(target).hasClass('js-btn-request_interview');
        const isCall = $(target).hasClass('js-btn-call');
        const isRequestedCardResend = $(target).hasClass('js-btn-requested_card_resend');
        let config = {
            showConfirmButton: true,
            showCancelButton: true,
            timer: null,
            allowOutsideClick: true,
            confirmButtonColor: '#16a378',
            cancelButtonText: "いいえ",
        };
        let addConfig = {};

        if (isRequestInterview) {  // 問診依頼
            addConfig = {
                title: '問診の入力を依頼する',
                text: 'LINEを送信しますがよろしいですか？',
                confirmButtonText: '送信する'
            }
        } else if (isCall) {
            addConfig = {
                title: '呼び出しする',
                text: '呼び出しは取り消しできません。よろしいですか？',
                confirmButtonText: '呼び出す'
            }
        } else if (isRequestedCardResend) {
            addConfig = {
                title: '再撮影依頼する',
                text: '再撮影依頼は取り消しできません。よろしいですか？',
                confirmButtonText: '再撮影依頼'
            }
        } else { // タブ移動
            addConfig = {
                title: `${text}に移動する`,
                text: '元に戻せませんがよろしいですか？',
                confirmButtonText: '移動する'
            }
        }
        config = { ...config, ...addConfig };

        Swal.fire(config).then((e) => {
            if (e.isConfirmed) {
                $.ajax({ url: link, type: "GET" });
                if (!isRequestInterview && !isCall && !isRequestedCardResend) {
                    $(target).closest('.js-waitlist').fadeOut();
                }
            }
        });
    }

    // 診察券画像 複数表示
    lightbox.option({
        'resizeDuration': 100,
        'wrapAround': true,
        'disableScrolling': false,
        'imageFadeDuration': 100,
        'fadeDuration': 100,
        'alwaysShowNavOnTouchDevices': true,
    });

    // ソトマチ一覧 検索条件変更
    $('#js-sotomachi-date, #js-sotomachi-required-item, #js-sotomachi-staff, #js-sotomachi-only-available-time').on('change', (e) => {
        $(e.target).closest("form").submit();
    });

    // ソトマチ一覧 検索条件変更
    $('#js-switch-tab-mode').on('change', (e) => {
        if ($(e.target).prop("checked")) {
            var newActionUrl = $(e.target).closest("form").attr('action').replace('waitings', 'holdings');
            $(e.target).closest("form").attr('action', newActionUrl);
        } else {
            var newActionUrl = $(e.target).closest("form").attr('action').replace('holdings', 'waitings');
            $(e.target).closest("form").attr('action', newActionUrl);
        }
        $(e.target).closest("form").submit();
    });

    // ソトマチ一覧 空きのみ表示無効化判定
    $('#js-sotomachi-required-item, #js-sotomachi-staff').on('change', () => {
        changeOnlyAvailableTimeState($('#js-sotomachi-only-available-time'), true);
    });

    changeOnlyAvailableTimeState($('#js-sotomachi-only-available-time'), false);

    function changeOnlyAvailableTimeState($requiredItem, $submitOrNot) {
        if ($('#js-sotomachi-required-item').val() || $('#js-sotomachi-staff').val()) {
            $requiredItem.prop('disabled', false);
            $requiredItem.prev().css("color", "black");
        } else {
            $requiredItem.prop('checked', false);
            $requiredItem.prop('disabled', true);
            $requiredItem.prev().css("color", "gray");
            if ($submitOrNot) {
                $requiredItem.closest("form").submit();
            }
        }
    }

    // 選択肢②のスキップ
    checkSkipOptional($('.js-form-required_item'));

    $('.js-form-required_item').on('change', (e) => {
        checkSkipOptional($(e.target));
    });

    function checkSkipOptional($requiredItem) {
        $optionalItemArea = $('.js-form-optional_item');
        $optionalItem = $optionalItemArea.find('select');

        // hidden_field の場合
        if ($requiredItem.find('option').length !== 0) {
            $requiredItem = $requiredItem.find('option:selected');
        }

        if ($requiredItem.data('skip-optional')) {
            $optionalItemArea.hide();
            $optionalItem.val('');
        } else {
            $optionalItemArea.show();
            // $optionalItem.val($optionalItem.find('option:first-child').val());
        }
    }

    // ブラウザバック カレンダー日付連動対応
    var url_path = location.pathname.split('/')
    // 受付リストページのみに限定
    if (url_path[2] === "waitlists" && url_path[3] === "waitings") {
        // For Safari （※Chromeも一部カバーケース有）
        var type = null;
        var perfEntries = performance.getEntriesByType("navigation");

        perfEntries.forEach(function (pe) {
            // タイプ取得
            type = pe.type;
        });

        // ブラウザバック/フォワード判定
        if (type == 'back_forward') {
            window.location.reload();
            return;
        }

        // For Chrome
        window.addEventListener('pageshow', function (event) {
            // cache利用時判定
            if (event.persisted) {
                window.location.reload();
                return;
            }
        });
    }

    // 仮予約登録ボタンクリック時
    $('.js-btn-tmp-reservation-submit').on('click', (e) => {
        $('#newTmpReservationModal').modal('hide');
    });

    setHeightToWaitlistArea()
    function setHeightToWaitlistArea() {
        // カレンダー表示ではない場合に処理を行う
        if (!document.getElementById('day-calendar')) {
            // waitlist-areaに高さを付与する
            const targetElements = document.getElementsByClassName('waitlist-area');
            for (let i = 0; i < targetElements.length; i++) {
                let documentHeight = window.innerHeight;
                // 比率で余白を決めるようにする
                let marginSize = documentHeight / 5.5;
                targetElements[i].style.height = `${documentHeight - marginSize}px`;
                targetElements[i].style.overflow = "scroll";
            }
        }
    }
});
